import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CustomerViewModel} from '../model/view/CustomerViewModel';
import {environment} from '../../../environments/environment';
import {BaseDao} from './dao/base.dao';
import {Customer} from "../model/CustomerModel";

@Injectable({
  providedIn: 'root'
})
export class CustomersService {
  constructor(private baseDao: BaseDao<CustomerViewModel>) {
  }

  findByNameOrEmail(nameOrEmail: string): Observable<CustomerViewModel[]> {
    const url = environment.links.customer.searchByNameOrEmail;
    const query = {customerId: nameOrEmail};
    const params = [];

    return this.baseDao.find(url, params, query, () => new CustomerViewModel());
  }

  findCustomerForReassigment(text: string, excludedCustomerUid: string, url: string): Observable<Customer[]> {
    const query = {text, excludedCustomerUid};
    const params = [];

    return this.baseDao.get(url, params, query, () => new CustomerViewModel());
  }

}
